export type GoalState = 'required' | 'completed' | 'skip_for_now' | 'dismissed'

export interface Goals {
  becomeAMoteCE: GoalState
  googleClassroom: GoalState
  googleDocsnumber: GoalState
  googleForms: GoalState
  googleSlides: GoalState
  linekerSurvey: GoalState
  loopOptIn: GoalState
  makeFirstMote: GoalState
  motepadUsage: GoalState
  productOnboarding: GoalState
  schoolSearchDuringUserOnboarding: GoalState
  speechToText: GoalState
  translation: GoalState
  userCreationFinalised: GoalState
  userOnboarding: GoalState
}

export function isGoalRequired(goalState: GoalState): goalState is 'required' {
  return goalState === 'required'
}
